module.exports = __webpack_public_path__ + "static/media/caret-top.fb1cd092.svg";